import api from '../lib/api'
import { faqErrorCode, faqErrorDetail, faqMessageParams } from './faq'

// Quick Answer API (backend `app/routers/quick_answers.py`), scoped to one tenant.
const base = (tenantId) => `/admin/tenants/${tenantId}/quick-answers`

// Response: { can_write, items: [Entry], starters: [{key, title, description, text}], limits,
//   mode: 'off'|'shadow'|'on', language: 'vi'|'en' }
// Entry: { id, title, description, enabled, text, attachments, created_at, updated_at, updated_by, warnings }
export const getQuickAnswers = (tenantId) => api.get(base(tenantId)).then((r) => r.data)

// body: { title, description, text, attachments }. A new entry is always disabled (201).
export const createQuickAnswer = (tenantId, body) =>
  api.post(base(tenantId), body).then((r) => r.data)

// Full replace; body: { title, description, enabled, text, attachments }.
export const updateQuickAnswer = (tenantId, id, body) =>
  api.put(`${base(tenantId)}/${id}`, body).then((r) => r.data)

export const deleteQuickAnswer = (tenantId, id) =>
  api.delete(`${base(tenantId)}/${id}`).then(() => undefined)

const upload = (tenantId, kind, file) => {
  const form = new FormData()
  form.append('file', file)
  return api.post(`${base(tenantId)}/attachments/${kind}`, form).then((r) => r.data)
}
export const uploadQuickAnswerImage = (tenantId, file) => upload(tenantId, 'image', file)
export const uploadQuickAnswerFile = (tenantId, file) => upload(tenantId, 'file', file)

export const RETRYABLE_QUICK_ANSWER_ERRORS = new Set([
  'authz_lookup_failed', 'tenant_lookup_failed', 'network', 'unknown', 'rate_limited', 'upload_failed',
])

export const quickAnswerErrorCode = faqErrorCode
export const quickAnswerErrorField = (error) => faqErrorDetail(error).field || null

export function quickAnswerErrorMessage(t, error) {
  const code = faqErrorCode(error)
  return t(`quickAnswer.errors.${code}`, {
    ...faqMessageParams(faqErrorDetail(error)),
    defaultValue: t('quickAnswer.errors.unknown'),
  })
}
